import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { Result, Button } from 'antd';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    const { hasError, eventId } = this.state;
    const { children } = this.props;

    const handleHomeClick = () => {
      this.setState({ hasError: false });
    };

    const handleReportclick = () => {
      Sentry.showReportDialog({ eventId });
    };

    if (hasError) {
      return (
        <Result
          status="error"
          title="Sorry, an unexpected error has occured"
          extra={
            <>
              <Button type="primary" onClick={handleHomeClick}>
                Home
              </Button>
              <Button type="primary" onClick={handleReportclick}>
                Report feedback
              </Button>
            </>
          }
        />
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
